import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import Button from '../components/UI/Button';

const TermsOfService: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900 py-12 px-4">
      <div className="max-w-3xl mx-auto">
        <div className="mb-8 flex items-center">
          <Button 
            variant="ghost" 
            className="mr-4"
            onClick={() => navigate(-1)}
          >
            <ArrowLeft className="h-5 w-5" />
          </Button>
          <h1 className="text-3xl font-bold">Conditions Générales de Vente</h1>
        </div>

        <div className="bg-white dark:bg-gray-800 rounded-lg shadow-md p-8 space-y-8">
          <section>
            <p className="text-gray-600 dark:text-gray-400">
              Les présentes Conditions Générales de Vente (CGV) régissent les relations contractuelles entre Invoice AI 
              et ses clients dans le cadre de la fourniture de services de génération de factures et devis assistée 
              par intelligence artificielle.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-4">2. Prix et modalités de paiement</h2>
            <p className="text-gray-600 dark:text-gray-400">
              Les prix de nos services sont indiqués en euros et hors taxes. Le paiement s'effectue par carte bancaire 
              via notre prestataire de paiement sécurisé Stripe.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-4">3. Durée et résiliation</h2>
            <p className="text-gray-600 dark:text-gray-400">
              L'abonnement est conclu pour une durée indéterminée avec une période minimale d'un mois. Le client peut 
              résilier son abonnement à tout moment depuis son espace client.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-4">4. Accès au service</h2>
            <p className="text-gray-600 dark:text-gray-400">
              Invoice AI s'engage à fournir un accès aux fonctionnalités de génération de devis et de factures tant que 
              l'abonnement du client est actif. L'accès peut être temporairement suspendu en cas de maintenance ou 
              d'incident technique sans que cela n'ouvre droit à indemnisation.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-4">5. Obligations du client</h2>
            <p className="text-gray-600 dark:text-gray-400">
              Le client s'engage à fournir des informations exactes et à jour lors de la création de son compte et dans 
              l'utilisation du service. Il est seul responsable de l'utilisation des documents générés (factures, devis) 
              ainsi que de leur conformité avec les obligations légales applicables à son activité.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-4">6. Propriété intellectuelle</h2>
            <p className="text-gray-600 dark:text-gray-400">
              Tous les éléments de la plateforme Invoice AI, y compris les textes, interfaces, logos, algorithmes, et 
              contenus générés automatiquement, sont protégés par le droit de la propriété intellectuelle. Toute 
              reproduction, diffusion ou utilisation sans autorisation est strictement interdite.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-4">7. Données personnelles</h2>
            <p className="text-gray-600 dark:text-gray-400">
              Invoice AI traite les données personnelles des clients conformément à sa politique de confidentialité et 
              en conformité avec le Règlement Général sur la Protection des Données (RGPD). Le client dispose d'un droit 
              d'accès, de rectification et de suppression de ses données.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-4">8. Responsabilité</h2>
            <p className="text-gray-600 dark:text-gray-400">
              Invoice AI ne saurait être tenue responsable de l'utilisation que fait le client des documents générés via 
              la plateforme. En aucun cas, la responsabilité d'Invoice AI ne pourra excéder le montant de l'abonnement 
              mensuel payé par le client.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-4">9. Modification des CGV</h2>
            <p className="text-gray-600 dark:text-gray-400">
              Invoice AI se réserve le droit de modifier les présentes CGV à tout moment. Les clients seront informés de 
              toute modification via l'interface de la plateforme ou par email. L'utilisation continue du service après 
              modification vaut acceptation des nouvelles conditions.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-4">10. Droit applicable et litiges</h2>
            <p className="text-gray-600 dark:text-gray-400">
              Les présentes CGV sont régies par le droit français. En cas de litige, une tentative de résolution amiable 
              sera privilégiée. À défaut, le différend pourra être porté devant les tribunaux compétents du ressort du 
              siège social d'Invoice AI.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default TermsOfService;